import { render, staticRenderFns } from "./GlobalBottomButton.vue?vue&type=template&id=2a78c054&"
import script from "./GlobalBottomButton.vue?vue&type=script&lang=js&"
export * from "./GlobalBottomButton.vue?vue&type=script&lang=js&"
import style0 from "./GlobalBottomButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports